import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useTexts } from '../../../hooks/useTexts';
import './Intro.css';

// ============================================================
//  Troque pelo ID do seu vídeo de showreel no YouTube
//  Ex: youtube.com/watch?v=XXXXXXXXXXX  →  ID = XXXXXXXXXXX
// ============================================================
const SHOWREEL_ID = 'su13IgtwXcU';

export default function Intro() {
  const t = useTexts();
  const [frame, setFrame] = useState(0);
  const [muted, setMuted] = useState(true);
  const tcRef = useRef(null);

  useEffect(() => {
    const iv = setInterval(() => setFrame(f => f + 1), 1000 / 24);
    return () => clearInterval(iv);
  }, []);

  const fr = String(frame % 24).padStart(2, '0');
  const s  = String(Math.floor(frame / 24) % 60).padStart(2, '0');
  const m  = String(Math.floor(frame / 1440) % 60).padStart(2, '0');
  const h  = String(Math.floor(frame / 86400)).padStart(2, '0');
  const timecode = `${h}:${m}:${s}:${fr}`;

  const videoSrc = `https://www.youtube.com/embed/${SHOWREEL_ID}?autoplay=1&mute=${muted ? 1 : 0}&loop=1&playlist=${SHOWREEL_ID}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1`;

  const fadeUp = (delay = 0) => ({
    initial: { opacity: 0, y: 28 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <section className="intro" id="top">

      {/* VIDEO FULLSCREEN BACKGROUND */}
      <div className="intro-video-bg">
        <iframe
          key={muted}
          className="cinema-video"
          src={videoSrc}
          title="Showreel"
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
        />
        <div className="intro-vignette" />
      </div>

      {/* TIMECODE BAR */}
      <div className="timecode-bar">
        <span className="tc-dot" />
        <span className="tc-mono">REC</span>
        <span ref={tcRef} className="tc-mono">{timecode}</span>
        <div className="tc-track"><div className="tc-fill" /></div>
        <span className="tc-mono">4K · 24fps</span>
        <span className="tc-mono tc-reel">{t.hero.reel}</span>
      </div>

      {/* CONTENT OVERLAY */}
      <div className="intro-content">
        <motion.p className="intro-tag" {...fadeUp(0.1)}>
          {t.hero.tag}
        </motion.p>

        <motion.h1 className="intro-title" {...fadeUp(0.25)}>
          <span>{t.hero.title1}</span>
          <span className="accent">{t.hero.title2}</span>
          <span className="outline">{t.hero.title3}</span>
        </motion.h1>

        <motion.p className="intro-sub" {...fadeUp(0.42)}>
          {t.hero.sub}
        </motion.p>

        <motion.div className="intro-cta" {...fadeUp(0.56)}>
          <a href="#work" className="btn-primary">{t.hero.cta1}</a>
          <a href="#contact" className="btn-ghost">{t.hero.cta2}</a>
        </motion.div>
      </div>

      {/* SOUND BUTTON */}
      <motion.button
        className="sound-btn"
        onClick={() => setMuted(prev => !prev)}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        aria-label={muted ? 'Ativar som' : 'Silenciar'}
      >
        {muted ? (
          <>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
              <line x1="23" y1="9" x2="17" y2="15"/>
              <line x1="17" y1="9" x2="23" y2="15"/>
            </svg>
            <span>SOM OFF</span>
          </>
        ) : (
          <>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
              <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
            </svg>
            <span>SOM ON</span>
          </>
        )}
      </motion.button>

      {/* SCROLL INDICATOR */}
      <div className="scroll-indicator">
        <div className="scroll-line" />
        <span className="scroll-txt">Scroll</span>
      </div>
    </section>
  );
}
